import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import {
  requestLayersList,
  // requestCreateLayer,
  requestDeleteLayer,
  requestUpdateLayer,
  requestUpdateTrait,
  requestDeleteTrait,
} from 'helpers/api';
import {
  // createLayerError,
  // createLayerSuccess,
  deleteLayerError,
  deleteLayerSuccess,
  deleteTraitError,
  deleteTraitSuccess,
  getLayersError,
  getLayersSuccess,
  setOrderLayerModal,
  updateLayerError,
  updateLayerListError,
  updateLayerListSuccess,
  updateLayerSuccess,
  updateTraitError,
  updateTraitSuccess,
} from './actions';
import {
  DELETE_LAYER,
  DELETE_TRAIT,
  // CREATE_LAYER,
  GET_LAYERS,
  UPDATE_LAYER,
  UPDATE_LAYER_LIST,
  UPDATE_TRAIT,
} from '../contants';

function* getLayers({ payload }) {
  try {
    const gotLayer = yield call(requestLayersList, payload);
    if (gotLayer.result) {
      // gotLayer.data should be an array of Layers
      yield put(getLayersSuccess(gotLayer.data));
    } else {
      yield put(getLayersError(gotLayer.message));
    }
  } catch (error) {
    yield put(getLayersError(error.message));
  }
}

export function* watchGetLayer() {
  yield takeEvery(GET_LAYERS, getLayers);
}

// function* createLayer({ payload }) {
//   const layer = payload;
//   try {
//     const result = yield call(requestCreateLayer, layer);
//     if (result.result) {
//       const item = result.layer;
//       yield put(createLayerSuccess(item));
//     } else {
//       yield put(createLayerError(result.message));
//     }
//   } catch (error) {
//     yield put(createLayerError(error.message));
//   }
// }

// export function* watchCreateLayer() {
//   yield takeEvery(CREATE_LAYER, createLayer);
// }

function* updateLayer({ payload }) {
  const result = yield call(requestUpdateLayer, payload);
  if (result.result) yield put(updateLayerSuccess(result.data));
  else yield put(updateLayerError(result.message));
}
export function* watchUpdateLayer() {
  yield takeEvery(UPDATE_LAYER, updateLayer);
}

async function requestUpdateLayerList(list = []) {
  const promises = [];
  list.forEach((v) => promises.push(requestUpdateLayer(v)));
  try {
    const values = await Promise.all(promises);
    return { result: true, data: values, message: 'Layer orders updated!' };
  } catch (error) {
    return { result: false, data: null, message: 'Layer orders not saved!' };
  }
}

function* updateLayerList({ payload }) {
  const result = yield call(requestUpdateLayerList, payload);
  if (result.result) {
    yield put(updateLayerListSuccess(result.data));
    yield put(setOrderLayerModal(false));
  } else yield put(updateLayerListError(result.message));
}
export function* watchUpdateListLayer() {
  yield takeEvery(UPDATE_LAYER_LIST, updateLayerList);
}

function* updateTrait({ payload }) {
  const result = yield call(requestUpdateTrait, payload);
  if (result.result) yield put(updateTraitSuccess(result.data));
  else yield put(updateTraitError(result.message));
}
export function* watchupdateTrait() {
  yield takeEvery(UPDATE_TRAIT, updateTrait);
}

function* deleteLayer({ payload }) {
  const result = yield call(requestDeleteLayer, payload);
  if (result.result) yield put(deleteLayerSuccess(result.data));
  else yield put(deleteLayerError({ message: result.message, id: payload.id }));
}
export function* watchDeleteLayer() {
  yield takeEvery(DELETE_LAYER, deleteLayer);
}

function* deleteTrait({ payload }) {
  const result = yield call(requestDeleteTrait, payload);
  if (result.result) yield put(deleteTraitSuccess(result.data));
  else yield put(deleteTraitError({ message: result.message, id: payload.id }));
}
export function* watchdeleteTrait() {
  yield takeEvery(DELETE_TRAIT, deleteTrait);
}

// Export root saga and add all watches here
export default function* rootSaga() {
  yield all([
    fork(watchGetLayer),
    // fork(watchCreateLayer),
    fork(watchUpdateLayer),
    fork(watchDeleteLayer),
    fork(watchupdateTrait),
    fork(watchdeleteTrait),
    fork(watchUpdateListLayer),
  ]);
}
